import { useState } from 'react';

/**
 * Indica si un formulario tiene cambios sin guardar: compara su estado actual con el que tenía
 * cuando se abrió la ventana (una foto en JSON tomada al pasar `abierto` a true).
 *
 * - Formulario de edición que carga el registro después de abrir: pasar
 *   `abierto = ventanaAbierta && registroCargado`, así la foto se toma con el registro ya cargado.
 * - Ventana que se abre ya precargada (p. ej. desde un PDF): pasar `referencia` (el formulario
 *   vacío) para que lo precargado cuente como cambio.
 */
export function useHayCambios(estado: unknown, abierto: boolean, referencia?: unknown): boolean {
  const actual = abierto ? JSON.stringify(estado) : null;
  const [inicial, setInicial] = useState(actual);
  const [abiertoAntes, setAbiertoAntes] = useState(abierto);
  // Al abrir (o cerrar) se toma la foto nueva durante el render, sin esperar a un efecto.
  const recienAbierto = abierto !== abiertoAntes;
  if (recienAbierto) {
    setAbiertoAntes(abierto);
    setInicial(actual);
  }
  if (!abierto) return false;
  if (referencia !== undefined) return actual !== JSON.stringify(referencia);
  return !recienAbierto && actual !== inicial;
}
